module.exports = __webpack_public_path__ + "img/emoji_22.894c5ecc.png";